<template>
  <multiselect
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    @input="$emit('input', $event)"
    :showLabels="showLabels"
    :placeholder="placeholder"
    :option-height="optionHeight"
  >
    <template v-for="(content, name) in $slots" :slot="name">
      <slot :name="name"><vnode :node="content"/></slot>
    </template>

    <template v-for="(content, name) in $scopedSlots" :slot="name" slot-scope="props">
      <slot :name="name" v-bind="props">
        <vnode :node="content"/>
      </slot>
    </template>

    <template slot="noResult" v-if="!$slots['noResult']">Не найдено</template>
  </multiselect>
</template>

<script>
  export default {
    props: {
      value: {},
      showLabels: {
        type: Boolean,
        default: () => false,
      },
      placeholder: {
        type: String,
        default: 'Выберите',
      },
      optionHeight: {
        type: Number,
        default: 28,
      },
    },
    methods: {},
  }
</script>

<style lang="scss">
  @import "~vue-multiselect/dist/vue-multiselect.min";
  .multiselect {
    /*z-index: 10;*/
    &--active {
      z-index: 1000;
    }
  }
  .multiselect__content-wrapper {
    z-index: 10;
  }
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: inherit;
  }
  .multiselect__option {
    padding: 6px 12px;
    line-height: 16px;
    min-height: 28px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/v-multiselect.vue